export const checkLogin = () => { //是否登录状态
  const userAccess = sessionStorage.getItem('_user_access_');
  const userInfo = sessionStorage.getItem('_user_info_');

  if (!userAccess || !userInfo) {

    return false;
  } else {
    return true;
  }
}





export const formatSalaryRange = (SALFROM, SALTO) => {
  // 改用Number解析，保留小数，不再用parseInt截断小数
  let from = SALFROM !== undefined ? Number(SALFROM) : undefined;
  let to = SALTO !== undefined ? Number(SALTO) : undefined;

  // 判断是否需要转k：任意一端 >=10000
  const shouldFormatToK = (from !== undefined && from >= 10000) || (to !== undefined && to >= 10000);

  // 内部格式化单个数字
  const formatSingle = (num) => {
    if (num === undefined) return undefined;

    if (shouldFormatToK) {
      const kVal = num / 1000;
      // 判断是否小数，小数保留2位，整数正常展示
      return kVal % 1 === 0 ? `${kVal}k` : `${kVal.toFixed(2)}k`;
    } else {
      // 小于1万：整数直接转字符串，小数保留两位
      return num % 1 === 0 ? num.toString() : num.toFixed(2);
    }
  };

  const formattedFrom = formatSingle(from);
  const formattedTo = formatSingle(to);

  return [formattedFrom, formattedTo];
};


export const getSalaryDisplay = (SALFROM, SALTO) => {  //薪资展示

    if (!SALFROM && !SALTO) {
        return '未填写';
    }
    // 情况 2: 两个值相等，显示该值
    if (SALFROM === SALTO) {
        return   SALFROM.toString()+"元";
    }
    
        // 情况 3: 两个值都存在且不相等，显示范围
    if (SALFROM && SALTO && SALFROM !== SALTO) {
        return `${SALFROM}-${SALTO}元`;
    }
    
        // 情况 4: SALFROM 为空，SALTO 存在，显示 SALTO 以下
    if ((SALFROM === '' || SALFROM === undefined) && SALTO) {
        return `${SALTO}元以下`;
    }
    
        // 情况 5: SALTO 为空，SALFROM 存在，显示 SALFROM 以上
    if ((SALTO === '' || SALTO === undefined) && SALFROM) {
        return `${SALFROM}元以上`;
    }
    return "面谈";
}

export const tagRedirect = (data, url) => {
  const currentUrl = window.location.href;
  const homeIndex = currentUrl.indexOf('home/');

  const params = new URLSearchParams(); //获取参数
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, String(value));
      }
    });
  }
  const paramsStr = params.toString();
  let urlWithParams = currentUrl;

  if (homeIndex !== -1) {
    let newUrl = currentUrl.substring(0, homeIndex + 'home/'.length);
    urlWithParams = newUrl + url;
  } else {
    urlWithParams = currentUrl + 'home/' + url;
  }
  if (paramsStr) {
    urlWithParams += `?${paramsStr}`;
  }


  window.open(urlWithParams, '_blank');
}